<p>button works!</p>
<button #myButton (click)="handleClick()">Clique em Mim</button>
